import { jsx as _jsx } from "react/jsx-runtime";
import { ToggleSwitch } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '../i18n/i18n';
import { useTracking } from '../hooks/use-tracking';
import { EventAction } from '../types/tracking';
export const ShowDifferencesToggle = ({ showDifferences, setShowDifferences, }) => {
    const { i18n } = useI18n();
    const { handleTrackEvent, baseTrackingEventName } = useTracking();
    const handleShowDifferencesTrackEvent = (checked) => {
        const eventName = `${baseTrackingEventName} - differences ${checked ? 'on' : 'off'}`;
        handleTrackEvent({
            eventInfo: {
                eventName,
                eventAction: EventAction.Content,
            },
            attributes: {
                label: i18n('compareLayer.header.showDifferences'),
                elementName: 'toggle',
            },
        });
    };
    return (_jsx(ToggleSwitch, { checked: showDifferences, "data-testid": "differences-toggle-switch", id: "differences-toggle-switch", label: i18n('compareLayer.header.showDifferences'), labelPosition: "trailing", name: "differences-toggle-switch", onChange: (e) => {
            const checked = e.target.checked;
            setShowDifferences(checked);
            handleShowDifferencesTrackEvent(checked);
        }, value: "differences-toggle-switch" }));
};
